export const fetchCaseById = {
  pathname: (id) => `/eod/cases/${id}`
}

export const fetchSummary = {
  pathname: '/eod/summary'
}

export const fetchCases = {
  pathname: '/eod/cases'
}
